import 'fancybox/dist/css/jquery.fancybox.css';
import 'fancybox/dist/js/jquery.fancybox.js';

export const gallery = () => {
  $('[data-fancybox]').fancybox();
  $('[data-fancybox="gallery"]').fancybox({
  });
}
